import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import {ThunkDispatch} from "@reduxjs/toolkit";
import staffAvatar from '../../../../assets/img/noAvatarAdmin.svg';
import staffAvatarText from '../../../../assets/img/noAvatarAdminText.svg';
import systemAvatar from '../../../../assets/img/systemAvatar.png';
import {formatName, formatPadStartNumber} from "utils/format";
import {setIsOpenListJobPanel, setJobSelected} from "reducers/chatMessage";
import { useNavigate } from "react-router-dom";
import i18n from 'i18next';
import CustomIconButton from "components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import {MESSAGE_TYPE} from "../../../constants/index";

const ChatBoxHeader = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { chatSelected, isChatting, staffSelected, jobSelected, isOpenListJobPanel } = useSelector((state: any) => state.chatMessage);
  let {talentInfo} = useSelector((state: any) => state.currentUser)
  const navigate = useNavigate();

  const handleSetIsOpenListJobPanel = () => {
    if(chatSelected?.type?.value == MESSAGE_TYPE.SCOUT || chatSelected?.type?.value == MESSAGE_TYPE.APPLY) {
      return
    }
    dispatch(setIsOpenListJobPanel(true));
  };

  const handleGoToJob = (e: any, jobId: number) => {
    e.stopPropagation()
    if(jobId) navigate("/talent/job/detail/" + jobId);
  }

  const unSelectJob = () => {
    dispatch(setJobSelected({}));
  };

  return (
    <div className="mt-2 mb-4 px-4 md:px-0 md:block">
      {isChatting && !chatSelected?.id && (
        <h2 className="hidden md:block font-bold alu-text-base-2 text-xl mb-2">
          新規メッセージ
        </h2>
      )}
      <div className={`mb-2 flex items-center gap-2`}>
        <label
          className="block shrink-0 min-w-[4rem] text-sm font-bold alu-text-base-2"
          htmlFor="email"
        >
          宛先
        </label>
        <div className={`${chatSelected?.id ? 'border border-[#E0E0E0]' : ''} w-full p-2 flex items-center gap-4 rounded-[0.25rem]`}>
          <div className="hidden md:block shrink-0 w-10 h-10 relative">
            <img
              className="hidden md:block shrink-0 w-[40px] h-[40px] rounded-full object-cover"
              src={chatSelected?.staff_avatar ? chatSelected?.staff_avatar : systemAvatar}
            />
            {chatSelected?.staff_avatar && chatSelected?.staff_avatar.split('/').includes('default_staff_avatar.svg') && <img src={staffAvatarText} alt="" className="absolute left-0 bottom-0 w-5 h-[0.625rem]" />}
          </div>
          <p className="text-sm font-bold alu-text-base-2">
          {chatSelected?.staff_name ? chatSelected?.staff_name : i18n.t('MSG_CHAT_DEFAULT_STAFF_NAME')}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="shrink-0 min-w-[4rem]">
          <label
            className="block text-sm font-bold alu-text-base-2"
            htmlFor="email"
          >
            求人情報
          </label>
        </div>
        {!jobSelected?.id ? (
          <>
            <CustomButton
              disabled={isOpenListJobPanel}
              onClick={handleSetIsOpenListJobPanel}
              customStyle="hidden md:block alu-text-base-2 !border-[#E0E0E0] leading-none"
              size="md"
              variant="outline"
            >
              求人を選ぶ
            </CustomButton>
            <CustomButton
              disabled={isOpenListJobPanel}
              onClick={handleSetIsOpenListJobPanel}
              customStyle="md:hidden alu-text-base-2 !border-[#E0E0E0]"
              size="md"
              variant="outline"
            >
              求人を選ぶ
            </CustomButton>
          </>
        ) : (
          <div onClick={handleSetIsOpenListJobPanel}
          className={`w-full ${chatSelected?.type?.value == MESSAGE_TYPE.SCOUT || chatSelected?.type?.value == MESSAGE_TYPE.APPLY ? "" : "hover:cursor-pointer"} p-2 flex items-center gap-4 justify-between rounded-[0.25rem] border border-[#E0E0E0]`}>
            <p className="flex-1 text-sm alu-text-base-2">
              <u className="alu-text-base-2 cursor-pointer hover:text-[#FF861A]" onClick={(e: any) => handleGoToJob(e, jobSelected?.id)}>{jobSelected?.title}</u>{" "}
              <span className="ml-[0.875rem] hidden md:inline-block alu-text-base-1 text-sm">
                id: {formatPadStartNumber(jobSelected?.id, 5)}
              </span>{" "}
              <br/>
              <span className="ml-[0.875rem] md:hidden alu-text-base-1 text-sm">
                id: {formatPadStartNumber(jobSelected?.id, 5)}
              </span>
            </p>
            <div
              className="min-w-[100px] shrink-0 flex items-center gap-1 rounded-[0.25rem] bg-[#F7F7F7] px-2 py-[0.375rem]">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                >
                  <circle cx="6.75" cy="6.5" r="6" fill={jobSelected?.is_available ? '#06C270' : '#BBB'} />
                </svg>
              </span>
              <p className="text-sm alu-text-base-2">{jobSelected?.status_str}</p>
            </div>
          </div>
        )}
        {!chatSelected?.id && jobSelected?.id ? (
          <CustomIconButton customStyle="shrink-0 self-center" onClick={unSelectJob}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
          </CustomIconButton>
        ): ''}
      </div>
    </div>
  );
};

export default ChatBoxHeader;
